import News from './components';

export default News;
